'use client';

import { Typography, Grid, Card, CardContent } from "@mui/material";
import { useAuth } from "../hooks/useAuth";

export const DeveloperStuff = () => {
  const auth = useAuth();

  return (
    <>
      <Typography width={'100%'} variant="h6" component="h2" gutterBottom>
        Developer stuff
      </Typography>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Card>
          <CardContent>
            <Typography variant="h6" component="h2" gutterBottom>
              Backend URL
            </Typography>
            <Typography variant="body2">
              {process.env.NEXT_PUBLIC_IMS_BACKEND_URL}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Card>
          <CardContent>
            <Typography variant="h6" component="h2" gutterBottom>
              Authenticated User Information (Provider: {auth.provider || 'No Provider Set'})
            </Typography>
            {auth.isAuthenticated ? (
              <>
                <Typography variant="body2" gutterBottom sx={{ color: 'green' }}>
                  Authenticated
                </Typography>
                {auth.accessToken ? (
                  <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                    {JSON.stringify(
                      (() => {
                        try {
                          const base64Url = auth.accessToken?.split('.')[1];
                          const base64 = base64Url?.replace(/-/g, '+').replace(/_/g, '/');
                          if (!base64) throw new Error('No JWT payload');
                          const jsonPayload = decodeURIComponent(
                            atob(base64)
                              .split('')
                              .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                              .join('')
                          );
                          return JSON.parse(jsonPayload);
                        } catch {
                          return { error: 'Invalid access token' };
                        }
                      })(),
                      null,
                      2
                    )}
                  </pre>
                ) : (
                  <Typography variant="body2">No access token available</Typography>
                )}
              </>
            ) : (
              <Typography variant="body2">Not authenticated</Typography>
            )}
          </CardContent>
        </Card>
      </Grid >
    </>
  )
}